export const isImage = (image: string) => {
    const imageRegex = /\.(jpg|jpeg|png|gif|bmp|svg)$/i;
    const dataImageRegex = /^data:image\/(jpeg|png|gif|bmp|svg\+xml);base64,/i;
    const fileExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
    const notEndRegex = new RegExp(`\\.(${fileExtensions.join("|")})(\\?|$)`, "i");
    return image.match(notEndRegex) || imageRegex.test(image) || dataImageRegex.test(image);
}